var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptionIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2L8.95347 5.54121C9.0698 5.97333 9.128 6.18939 9.2428 6.36603C9.3444 6.52233 9.47767 6.65557 9.634 6.7572C9.8106 6.872 10.0267 6.9302 10.4588 7.04653L14 8L10.4588 8.95347C10.0267 9.0698 9.8106 9.128 9.634 9.2428C9.47767 9.3444 9.3444 9.47767 9.2428 9.634C9.128 9.8106 9.0698 10.0267 8.95347 10.4588L8 14L7.04653 10.4588C6.9302 10.0267 6.872 9.8106 6.7572 9.634C6.65557 9.47767 6.52233 9.3444 6.36603 9.2428C6.18939 9.128 5.97333 9.0698 5.54121 8.95347L2 8L5.54121 7.04653C5.97333 6.9302 6.18939 6.872 6.36603 6.7572C6.52233 6.65557 6.65557 6.52233 6.7572 6.36603C6.872 6.18939 6.9302 5.97333 7.04653 5.54121L8 2Z",
    fill: "#10A37F",
    stroke: "#10A37F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionIcon);
export default __webpack_public_path__ + "static/media/subscriptionIcon.2e1210227f8a44419e8156ed811e64e3.svg";
export { ForwardRef as ReactComponent };